import(/* webpackMode: "eager" */ "/app/app/terms/page.tsx");
